import { createAction } from '@/utils/api'
import { IHolderAccount } from '../types'

// 當分支與 V3 合併時，請刪除此段檔案

/**
 * 客戶資訊 v3
 */
export const loadAccountV3 = createAction<
  // Response
  {
    account: IHolderAccount & {
      /** 此帳戶資料是否為草稿 */
      draft: boolean
    }
  },
  {
    account_id: number
    /** 是否優先取用草稿 */
    draft?: 1 | 0
  }
>('GET', '/api/:locale/dealings/v3/accounts/:account_id')